<!--element 分页组件-->
<template>
	<div class="pagination">
        <el-pagination :total="total" :page-size="pageSize" background :current-page.sync="pageIndex" @current-change="pageindexChange" 
        @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    </div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
                pageIndex: 1,
            }
        },
        props: {
            total:{
                type: Number,
                required: false,
                default: 0
            },
            pageSize:{
                type: Number,
                required: false,
                default: 20
            }
        },
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
            //size变化
            handleSizeChange(val) {
                this.pageIndex = 1;
                this.$emit('handleSizeChange', val);
            },
            //当前页
            pageindexChange(val){
                this.$emit('pageindexChange', val);
            }
		}
	}
</script>

<style scoped>
.pagination{
    display: flex;
    width: 98%;
    justify-content : flex-end;
    align-items : center;
    height: 6%;
}
</style>